import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className="footer-container">
            <p>Copyright © 2024 Kxysl1k Team. All rights reserved. No downloading, copying or editing allowed</p>
        </div>
    );
}

export default Footer;